<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-button/tge-button.jade
	.asw-results_search(:class="{ 'search-active': searchValue }")
		.asw-results_search_main
			input.asw-results_search_input(v-model="searchValue", :placeholder="placeholder", @blur="inputBlur", @focus="focusHandler")
			transition(appear, name="fade")
				.asw-results_search_results(v-if="searchValue && focused", :key="focused")
					.asw-results_search_result(v-for="electorate in searchResults", @click="resultClick(electorate)")
						|{{ electorate.properties.Elect_div }}
					.asw-results_search_error(v-if="noMatches") No Results for:
						em {{ searchValue }}

		transition(appear, name="fade")
			+tge-button({
				text: 'Clear',
				icon: 'close',
				customClasses: ['all-results_filter_button'],
				customAttributes: { ':searchValue': 'searchValue', '@click': 'searchValue = null', 'v-if': 'searchValue' }
			})

</template>
<script>
	export default {
		name: "asw-search",
		props: {
			electorates: {
				type: Array
			}
		},
		data: () => ({
			searchValue: null,
			// showDropdown: false,
			focused: false,
			placeholderText: "Search for your electorate."
		}),
		computed: {
			searchResults() {
				return this.electorates
					.filter( ({ properties }) => properties.Elect_div.toLowerCase().match(this.searchValue.toLowerCase()))
					//.filter( ({ properties }) => properties.region_name.toLowerCase().match(this.searchValue.toLowerCase()))
			},
			noMatches() {
				return !this.searchResults.length;
			},
			showDropdown() {
				return this.focused;
			},
			placeholder() {
				return this.focused ? '' : this.placeholderText;
			},
			searchInputTrackingData() {
				return {
					events: 'event10',
					site: window.utag ? window.utag.data.net_site : null,
					section: window.utag ? window.utag.data.net_sec2 : null,
					container: 'federal-election-2019',
					label: 'emoji-sentiment-map',
					order: '1',
					contenttype: window.utag ? window.utag.data.net_content_type : null,
					pagename: window.utag ? window.utag.data.net_pn : null
				}
			}
		},
		methods: {
			resultClick(result) {
				this.$emit('searchResultClick', result)
			},
			inputBlur() {
				setTimeout(() => {
					this.focused = false;
				}, 100)

			},
			focusHandler() {
				this.inputClick();
				this.trackingData();
			},
			inputClick() {
				this.focused = true;
			},
			trackingData() {
				
				if (window.utag) {
					const metric = 'ev';

					if (this.searchInputTrackingData) {
						this.sendAnalytics(metric, {
							events: [this.searchInputTrackingData.events],
							itm: {
								site: this.searchInputTrackingData.site,
								section: this.searchInputTrackingData.section,
								container: this.searchInputTrackingData.container,
								label: this.searchInputTrackingData.label,
								order: this.searchInputTrackingData.order,
								pagename: this.searchInputTrackingData.pagename,
								contenttype: this.searchInputTrackingData.contenttype
							}
						});
					}
				}
				
			},
			sendAnalytics(metricType, metricObj) {
				//console.log('metricType', metricType);
				//console.log('metricObj', metricObj);

				if (typeof metricType === 'undefined') {
					return;
				}

				window.mready = window.mready || [];
				window.mready.push(function(metrics) {
					metrics[metricType](metricObj);
					//console.log('sentiment metrics pushed');
				});
			}
		}
	}
</script>
<style lang="scss">
	@import "src/assets/scss/global-sass";
	@import 'node_modules/tangram-ui/src/elements/tge-button/tge-button';
	@import 'node_modules/tangram-ui/src/elements/tge-button/tge-button-dependencies';

	.asw-results_search {
		padding: 0 0 $m-spacing;
		position: relative;
		z-index: 20;
		display: inline-flex;
		/*
		&.search-active + .asw-map_container {
			opacity: 0.5;
		}
		*/

		&_main {
			position: relative;
		}
		&_input {
			padding: #{$m-spacing} $m-spacing;
		    width: 230px;
			height: 36px;
		}

		.tge-button {
			margin-left: $m-spacing;
		}

		&_error {
			padding: $m-spacing $m-spacing-x2;
			color: rgb(215, 48, 39);
			font-size: 0.8em;
			em { padding-left: $m-spacing }
		}

		&_results {
			position: absolute;
		    top: 100%;
			left:0;
		    z-index: 10;
		    background: #fff;
		    border: 1px solid #d3d3d3;
		    width: 100%;
			max-height: 316px;
			overflow: scroll;
		}
		&_result {
			padding: $m-spacing $m-spacing-x2;
			transition: all 0.3s;
			cursor: pointer;
			&:not(:first-child) {
				border-top: 1px solid #eee;
			}
			&:hover {
				background-color: #eee;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Search.vue